/// <reference path="../../typings/index.d.ts"/>

import * as React from "react";

export interface ButtonProps extends React.Props<Button> {
    caption: string;
    className?: string;
    onClick: any;
}

export interface ButtonState {

}

export class Button extends React.Component<ButtonProps, ButtonState> {
    constructor(props: ButtonProps) {
        super(props);

        this.state = {
            
        }
    }

    public render() {
        return (
            <button type="button" className={this.props.className} onClick={this.props.onClick}>
                {this.props.caption}
            </button>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Button.tsx
 **/